(function () {
    "use strict";

    var serviceId = "notificationService";

    angular.module("app.common").factory(serviceId, notificationService);

    notificationService.$inject = [
        "$q",
        "notification_factory",
        "notifierSvc",
        "CacheFactory",
        "$rootScope",
        "moment",
        "$translate"
    ];

    function notificationService(
        $q,
        notification_factory,
        notifierSvc,
        CacheFactory,
        $rootScope,
        moment,
        $translate
    ) {
        var service = {
            list: list,
            read: read,
            readAll: readAll,
            purgeCache: purgeCache,
            getNotifications: getNotifications,
            notifications: [],
            params: {page: 1, itemsPerPage: 20},
        };

        function list(query) {
            var deferred = $q.defer();
            notification_factory.list(query).$promise.then(function (result) {
                deferred.resolve(result.mobileDeviceNotificationDtos);
            }, function (err) {
                console.error(err);
                deferred.reject();
            });

            return deferred.promise;
        }

        function getNotifications () {
            var deferred = $q.defer();
            $rootScope.unreadNotifications = 0;
            service.notifications.length = 0;
            service.list(service.params).then(function (result) {
                if ($rootScope.upcomingPayment && $rootScope.upcomingPayment.unpaidPrice > 0 && $rootScope.upcomingPayment.paymentDaysRemaining <= $rootScope.upcomingPayment.notificationTreshold) {
                    var productName = $rootScope.lang === 'tr'
                        ? $rootScope.upcomingPayment.product.nameTurkish
                        : $rootScope.upcomingPayment.product.nameEnglish;
                    var upcomingPayment = {
                            createdDate: $rootScope.upcomingPayment.notificationCreatedDate,
                            isRead: $rootScope.upcomingPayment.notificationIsRead,
                            key: 300,
                            content: (() => {
                                var translateKey;
                                if ($rootScope.upcomingPayment.paymentDaysRemaining > 0) {
                                    translateKey = 'n_payment_warning';
                                } else if ($rootScope.upcomingPayment.paymentDaysRemaining === 0) {
                                    translateKey = 'n_payment_warning_today';
                                } else {
                                    translateKey = 'n_payment_warning_past';
                                }
                                return $translate.instant(translateKey, {productName: productName, daysRemaining: Math.abs($rootScope.upcomingPayment.paymentDaysRemaining)}) + ' ' + $translate.instant('n_payment_warning_click');
                            })(),
                            title: "Payment Reminder",
                        };
                    result.unshift(upcomingPayment);
                }
                result.map(function (n) {
                        if (n.key !== 300) {
                            let utc = new Date(n.createdDate);
                            var offset = utc.getTimezoneOffset($rootScope.lang);
                            var local = new Date(utc.getTime() - offset * 60000);
                            n.createdDate = local;
                        }
                        if (n.key !== 50 && !n.isRead) $rootScope.unreadNotifications++;
                        service.notifications.push(n);
                });
                deferred.resolve(service.notifications);
            })
        }

        function read (notification) {
            var deferred = $q.defer();
            if (notification.key === 300) {
                if (!notification.isRead) {
                    $rootScope.upcomingPayment.notificationIsRead = true;
                    $rootScope.setUpcomingPaymentToCookie($rootScope.upcomingPayment);
                    if ($rootScope.unreadNotifications > 0) {
                        $rootScope.unreadNotifications--;
                    }
                }
                deferred.resolve();
                return deferred.promise;
            }
            notification_factory.read({notificationId: notification.id, isRead: true}).$promise
            .then(function () {
                service.purgeCache();
                service.getNotifications();
                deferred.resolve();
            }, function () {
                deferred.reject();
            })

            return deferred.promise;
        }

        function readAll () {
            var deferred = $q.defer();
            notification_factory.readAll().$promise
            .then(function () {
                service.purgeCache();
                service.getNotifications();
                deferred.resolve();
            }, function (err) {
                console.error(err);
                deferred.reject();
            })

            return deferred.promise;
        }

        function purgeCache () {
            CacheFactory.get('NotificationList') && CacheFactory.get('NotificationList').removeAll();
        }

        return service;
    }
})();